import { AbstractBaseLayerState } from '../../../../../../cross-team-shared/annotation/shared/state/layers/abstract-base-layer-state';
import { ShapeLayerState } from './shape-layer-state';
import { TransientShapeLayerState } from './transient-shape-layer-state';

export class VectorLayerState
  extends AbstractBaseLayerState
  implements ShapeLayerState
{
  override readonly type = 'vector_tagging';

  constructor(
    width: number,
    height: number,
    public transient: TransientShapeLayerState,
  ) {
    super(width, height);
  }
}
